import { Small } from 'foundations-components/transitional/components/Small';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { HomeIcon } from 'foundations-assets/icons/components/HomeIcon';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BrowserUrlDisplay = ({
  url
}) => {
  if (!url) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "border-core-subtle",
    borderRadius: "200",
    justifyContent: "start",
    flexDirection: "row",
    children: [/*#__PURE__*/_jsx(Box, {
      padding: "200",
      shrink: 0,
      children: /*#__PURE__*/_jsx(HomeIcon, {
        color: "icon-core-subtle",
        size: "500"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      backgroundColor: "fill-surface-default",
      borderRadius: "100",
      gap: "200",
      inlineSize: "100%",
      marginBlock: "200",
      marginInlineEnd: "300",
      padding: "100",
      paddingInlineStart: "200",
      children: [/*#__PURE__*/_jsx(LockedIcon, {
        color: "icon-core-subtle",
        size: "200"
      }), /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(TruncateString, {
          matchContentWidth: true,
          children: url
        })
      })]
    })]
  });
};
export default BrowserUrlDisplay;